import {
  Backdrop,
  Box,
  Button, CircularProgress,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  InputLabel, TextField,
} from '@material-ui/core';
import React, { FormEvent, useState } from 'react';
import { saveUserGroupImage } from '../../service/storage';
import useApplication from '../../context/ApplicationContext';
import { UserGroupType } from '../../model/Types';
import { updateUserGroup } from '../../service/firestore';

interface AddUserGroupProps {
  updateUserGroups: () => void;
  userGroup: UserGroupType;
  dialogIsOpen: boolean;
  toggleDialog: () => void;
}

const AddUserGroup = ({
  updateUserGroups, userGroup, dialogIsOpen, toggleDialog,
}: AddUserGroupProps) => {
  const [backDropOpen, setBackdropOpen] = useState<boolean>(false);
  const { user } = useApplication();

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    const target = e.target as typeof e.target & {
      name: { value: string };
      description: { value: string };
      file: { files?: File[] };
    };

    const newUserGroup: Partial<UserGroupType> = {
      name: target.name.value || userGroup.name,
      description: target.description.value || userGroup.description,
    };

    if (target.file.files && target.file.files[0] && user?.uid) {
      saveUserGroupImage(userGroup.uid, target.file.files[0]);
      newUserGroup.imageName = (target.file.files[0].name);
    }

    setBackdropOpen(true);
    updateUserGroup(userGroup.uid, newUserGroup).then(() => {
      toggleDialog();
    }).catch((error) => {
      // eslint-disable-next-line no-console
      console.error(error.message);
    }).finally(() => {
      setBackdropOpen(false);
      updateUserGroups();
    });
  };

  return (
    <>
      <Dialog disableBackdropClick disableEscapeKeyDown fullWidth maxWidth="md" open={dialogIsOpen} onClose={toggleDialog} aria-labelledby="form-dialog-title">
        <form onSubmit={onSubmit}>
          <DialogTitle id="form-dialog-title">
            {userGroup.name}
            {' '}
            bearbeiten
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Bearbeiten Sie hier die Eigenschaften Ihrer Benutzergruppe.
            </DialogContentText>

            <TextField defaultValue={userGroup.name} autoFocus margin="normal" id="name" label="Name der Benutzergruppe" fullWidth />
            <TextField defaultValue={userGroup.description} multiline margin="normal" id="description" label="Beschreibung der Benutzergruppe" fullWidth />

            <Box marginTop={5}>
              <InputLabel>Bild ändern</InputLabel>
              <input type="file" name="file" id="file" accept="image/png, image/jpeg, image/jpg" />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={toggleDialog} color="primary">
              Abbrechen
            </Button>
            <Button type="submit" color="primary">
              Speichern
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <Backdrop open={backDropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default AddUserGroup;
